<template>
	<ul class="SkipTo">
		<li v-for="link in links" :key="link.href">
			<a :href="link.href">{{ link.label }}</a>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'CloSkipTo',
	props: {
		/**
		 * Array of links for the component
		 */
		links: {
			type: Array,
			required: true
		}
	}
}
</script>

<style lang="scss">
.SkipTo {
	display: flex;
	flex-direction: row;
	margin: 0;
	li {
		display: block;
		margin: 0;
	}
	a {
		@include inline-sm;
		&:not(:focus) {
			@include visuallyHidden;
		}
		&:focus {
			display: inline-block;
		}
	}
}
</style>